import React from "react";
import { Chip, ChipProps, Tooltip } from "@mui/material";
import { green, red } from "@mui/material/colors";
import { ICellRendererParams } from "ag-grid-community";

const TagCellRenderer: React.FC<ICellRendererParams<string>> = ({ value }) => {
  const common: Pick<ChipProps, "size" | "variant"> & { "data-testid": string } = {
    size: "small",
    variant: "outlined",
    "data-testid": "permission-chip",
  };

  if (value === "new") {
    return <Chip label="new" {...common} style={{ color: green[500], borderColor: green[500] }} />;
  } else if (value === "remove") {
    return <Chip label="remove" {...common} style={{ color: red[500], borderColor: red[500] }} />;
  } else if (value === "modified") {
    return <Chip label="modified" {...common} color="primary" />;
  } else if (value === "inherited") {
    return (
      <Tooltip title="This item has permissions inherited from its parent folder.">
        <Chip label="inherited" {...common} />
      </Tooltip>
    );
  }

  return <div />;
};

export default TagCellRenderer;
